import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { kebabCase } from 'lodash';
import theme from '~/theme';

import Icon from '~/components/base/Icon';

import { h4 } from '~/styles/typography';

import { formatText } from '~/utilities/helpers';

const Features = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 20px;
    ${h4}

    ${({ customCss }) => customCss};
`;

const Feature = styled.li`
    display: flex;
    align-items: center;
    gap: 20px;
`;

const StyledIcon = styled(Icon)`
    flex-shrink: 0;
`;

const IconList = ({ features, iconColor = 'black', customCss = {} }) => (
    <Features {...{ customCss }}>
        {features.map(({ icon, feature }) => (
            <Feature key={`${icon}-${kebabCase(feature)}`}>
                <StyledIcon
                    {...{ icon }}
                    color={iconColor}
                    sizeLarge={30}
                    size={30}
                    sizeMobile={25}
                />
                <span>{formatText(feature)}</span>
            </Feature>
        ))}
    </Features>
);

IconList.propTypes = {
    features: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string,
            feature: PropTypes.string.isRequired
        })
    ).isRequired,
    iconColor: PropTypes.oneOf(Object.keys(theme.iconColors)),
    customCss: PropTypes.object
};

export default IconList;
